module.exports = __webpack_public_path__ + "img/GAME_SOUNDLINK2.7dc79ddb.jpg";